export const rectsOverlap = (a, b) => {
  const aLeft = a.x;
  const aRight = a.x + a.width;
  const aTop = a.y;
  const aBottom = a.y + a.height;

  const bLeft = b.x;
  const bRight = b.x + b.width;
  const bTop = b.y;
  const bBottom = b.y + b.height;

  return !(
    aRight <= bLeft ||
    aLeft >= bRight ||
    aBottom <= bTop ||
    aTop >= bBottom
  );
};

export const normalizeZIndexes = (items) => {
  const sorted = [...items].sort((a, b) => {
    const az = a.z_index ?? 0;
    const bz = b.z_index ?? 0;

    if (az !== bz) return az - bz;
    return a.id - b.id;
  });

  return sorted.map((item, index) => ({
    ...item,
    z_index: index,
  }));
};

export const moveSelectedOneStepGlobal = (items, selectedId, direction) => {
  const normalized = normalizeZIndexes(items);
  const sorted = [...normalized].sort((a, b) => a.z_index - b.z_index);

  const currentIndex = sorted.findIndex((item) => item.id === selectedId);
  if (currentIndex === -1) return items;

  const targetIndex =
    direction === "forward"
      ? Math.min(sorted.length - 1, currentIndex + 1)
      : Math.max(0, currentIndex - 1);

  if (targetIndex === currentIndex) return normalized;

  const temp = sorted[currentIndex];
  sorted[currentIndex] = sorted[targetIndex];
  sorted[targetIndex] = temp;

  return sorted.map((item, index) => ({
    ...item,
    z_index: index,
  }));
};

export const moveSelectedToEdgeGlobal = (items, selectedId, direction) => {
  const normalized = normalizeZIndexes(items);
  const sorted = [...normalized].sort((a, b) => a.z_index - b.z_index);

  const currentIndex = sorted.findIndex((item) => item.id === selectedId);
  if (currentIndex === -1) return items;

  const [selected] = sorted.splice(currentIndex, 1);

  if (direction === "front") {
    sorted.push(selected);
  } else {
    sorted.unshift(selected);
  }

  return sorted.map((item, index) => ({
    ...item,
    z_index: index,
  }));
};

export const moveSelectedOneStepOverlap = (items, selectedId, direction) => {
  const normalized = normalizeZIndexes(items);
  const selected = normalized.find((item) => item.id === selectedId);
  if (!selected) return items;

  const overlaps = normalized.filter(
    (item) => item.id !== selectedId && rectsOverlap(item, selected)
  );

  if (overlaps.length === 0) return normalized;

  const selectedZ = selected.z_index ?? 0;
  let candidate = null;

  if (direction === "forward") {
    const higher = overlaps
      .filter((item) => (item.z_index ?? 0) > selectedZ)
      .sort((a, b) => (a.z_index ?? 0) - (b.z_index ?? 0));
    candidate = higher[0] || null;
  } else {
    const lower = overlaps
      .filter((item) => (item.z_index ?? 0) < selectedZ)
      .sort((a, b) => (b.z_index ?? 0) - (a.z_index ?? 0));
    candidate = lower[0] || null;
  }

  if (!candidate) return normalized;

  const updated = normalized.map((item) => {
    if (item.id === selected.id) {
      return { ...item, z_index: candidate.z_index };
    }
    if (item.id === candidate.id) {
      return { ...item, z_index: selected.z_index };
    }
    return item;
  });

  return normalizeZIndexes(updated);
};